The identifier for the reason the position was not posted. This corresponds to the `reasonId` field in the GraphQL schema, and should be supplied to the `positionNotPostedReason` query to retrieve the reason a position has not been posted.
